import React, {JSX, ReactNode} from 'react'
import {media} from 'style/media'
import {ThemeProvider} from 'styled-components'

type ThemeType = ({children}: {readonly children: ReactNode}) => JSX.Element

export const Theme: ThemeType = ({children}) => (
	<ThemeProvider
		theme={{
			...media,
		}}
	>
		{children}
	</ThemeProvider>
)
